import { useState } from 'react';
import automobyApi from '../Api';
import { useUpdateEffect } from './useUpdateEffect';

export const useTask = (defaultPageSize) => {
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0); 
  const [filter, setFilter] = useState({
    all: true,
    limit: defaultPageSize,
    order_by: "id",
    page: 1,
    name: "", 
  });

  useUpdateEffect(() => {
    fetchList();
  }, [filter]);
 
  const fetchList = async () => {
    try {
      const response = await automobyApi.post("/task/list", filter)
      setItems(response.data.tasks);
      setTotal(response.data.total);
      return response.data.tasks
    } catch (error) { 
      console.error("თუ ერორია:" + error);
    }
  }

  const fetch = async () => {
    try {
      const requestData = {
        all: true,
        limit: 100,
        order_by: "id",
        offset: 1
      };

      const response = await automobyApi.post("/task/all", requestData)
      setItems(response.data.tasks);
      setTotal(response.data.total);
      return response.data.tasks
    } catch (error) {

      console.error("თუ ერორია:" + error);
    }
  }

  const add = async (newData) => {
    try {
      const response = await automobyApi.post(`/task/create`, newData);
      fetchList();
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  const search = async (task, count) => {
    try {
      const requestData = {
        task: task,
        count: count,
      };

      const response = await automobyApi.post("/task/search", requestData)
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  const update = async (newData) => {
    try {
      const response = await automobyApi.post(`/task/update`, newData);
      fetchList();
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  const remove = (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const requestData = {
          task_id: id
        };
        const response = await automobyApi.post(`/task/delete`, requestData);
        fetchList();
        resolve(response);
      } catch (error) {
        reject(error);
      }
    });
  } 

 

  const taskService = {
    items: items,
    total: total,
    filter: filter, 
    setFilter: setFilter,
    fetch: fetch,
    fetchList: fetchList,
    add: add,
    search: search,
    update: update,
    remove: remove, 
  };

  return { taskService };
}